import React from 'react';
import { cn } from '@discover-lib/utils';

export type RestaurantCardRootProps = React.ComponentPropsWithRef<'div'>;

const RestaurantCardRoot = React.forwardRef<HTMLDivElement, RestaurantCardRootProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'group grid grid-cols-[auto_1fr] items-stretch gap-x-3 gap-y-4 md:gap-x-6 md:gap-y-5 lg:items-start',
        className
      )}
      {...props}
    />
  )
);

RestaurantCardRoot.displayName = 'RestaurantCardRoot';

export default RestaurantCardRoot;
